import {
  Dialog as BlueprintDialog,
  DialogProps as BlueprintDialogProps,
} from '@blueprintjs/core';
import { Close } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';

import { Button, ButtonProps } from 'bones/design-system/components/Button';
import { Heading } from 'bones/design-system/components/typography/Heading';

const BUTTON_SIZE_BY_HEADER_SIZE: Record<
  ModalProps['headerSize'],
  ButtonProps['size']
> = {
  lg: 'md',
  md: 'sm',
};

export type ModalProps = Omit<BlueprintDialogProps, 'title' | 'icon'> & {
  'data-testid'?: never;
  bodyTestId?: string;
  closeIconTestId?: string;
  footerActions?: React.ReactNode;
  headerSize: 'lg' | 'md';
  testId?: string;
  title?: string;
};

export const Modal: React.VFC<ModalProps> = ({
  bodyTestId,
  children,
  className,
  closeIconTestId,
  footerActions,
  headerSize,
  isCloseButtonShown = true,
  onClose,
  testId,
  title,
  ...props
}) => (
  <BlueprintDialog
    className={classNames(className, 'vb-modal')}
    data-testid={testId}
    onClose={onClose}
    portalContainer={
      (process.env.NODE_ENV === 'test' &&
        document.getElementById('vet-bones-root')) ||
      // istanbul ignore next
      undefined
    }
    shouldReturnFocusOnClose={false}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    <>
      {isCloseButtonShown || title ? (
        <div
          className={classNames(
            'vb-modal-header',
            `vb-modal-header-size--${headerSize}`
          )}
        >
          <Heading size="md" weight="semibold">
            {title}
          </Heading>
          {isCloseButtonShown ? (
            <Button
              leftIcon={Close}
              onClick={onClose}
              size={BUTTON_SIZE_BY_HEADER_SIZE[headerSize]}
              testId={closeIconTestId}
              variant="ghost-gray"
            />
          ) : null}
        </div>
      ) : null}
      <div className="vb-modal-body" data-testid={bodyTestId}>
        {children}
      </div>
      {footerActions ? (
        <div className="vb-modal-footer">{footerActions}</div>
      ) : null}
    </>
  </BlueprintDialog>
);
